/*
 *
 * Register Actions
 *
 * @version 1.0.0
 * @author Giuseppe
 * @since 30-Jan-2023
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index';

export const actionTypes = {
	DO_SET_ITEM_TO_SHOW_DETAIL: '@@/set_item_to_show_detail',
	DO_RESET_ERROR: '@@/reset_error',
	// @generator action:route:type
	...createRequestTypes('@@Register', 'CREATE_REGISTER'),
	...createRequestTypes('@@Register', 'DELETE_REGISTER'),
	...createRequestTypes('@@Register', 'DETAIL_REGISTER'),
	...createRequestTypes('@@Register', 'FIND_REGISTER'),
	...createRequestTypes('@@Register', 'LIST_REGISTERS'),
	...createRequestTypes('@@Register', 'UPDATE_REGISTER'),
	// @generator action:route:type:request
};

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request
/** @action request
 * * Insert a description
 * @name updateRegister
 * @return {object} - The action object
 */
export const updateRegister = new MakeRequest('Register', 'update_register');
/** @action request
 * * Insert a description
 * @name listRegisters
 * @return {object} - The action object
 */
export const listRegisters = new MakeRequest('Register', 'list_registers');
/** @action request
 * * Insert a description
 * @name findRegister
 * @return {object} - The action object
 */
export const findRegister = new MakeRequest('Register', 'find_register');
/** @action request
 * * Insert a description
 * @name detailRegister
 * @return {object} - The action object
 */
export const detailRegister = new MakeRequest('Register', 'detail_register');
/** @action request
 * * Insert a description
 * @name deleteRegister
 * @return {object} - The action object
 */
export const deleteRegister = new MakeRequest('Register', 'delete_register');
/** @action request
 * * Insert a description
 * @name createRegister
 * @return {object} - The action object
 */
export const createRegister = new MakeRequest('Register', 'create_register');
// @generator action:route
/** @action
 * * Insert a description
 * @name ResetError
 * @return {object} - The payload object
 */
export const doResetError = (payload) => createAction(actionTypes.DO_RESET_ERROR, { payload });
/** @action
 * * Insert a description
 * @name SetItemToShowDetail
 * @return {object} - The payload object
 */
export const doSetItemToShowDetail = (payload) => createAction(actionTypes.DO_SET_ITEM_TO_SHOW_DETAIL, { payload });
